import { createContext } from "react";
var defaultPlayerState = {
    player: null,
    setPlayer: function () {
        // do nothing.
    },
    autoPaused: false,
    setAutoPaused: function () {
        // do nothing.
    },
};
export var PlayerContext = createContext(defaultPlayerState);
